import { Serializable } from "@siteimprove/alfa-json";
/**
 * A bound, either inclusive or exclusive.
 *
 * @public
 */
export class Bound {
    static of(value, isInclusive) {
        return new Bound(value, isInclusive);
    }
    _value;
    _isInclusive;
    constructor(value, isInclusive) {
        this._value = value;
        this._isInclusive = isInclusive;
    }
    get value() {
        return this._value;
    }
    get isInclusive() {
        return this._isInclusive;
    }
    map(mapper) {
        return new Bound(mapper(this._value), this._isInclusive);
    }
    hasValue(refinement) {
        return refinement(this._value);
    }
    toJSON() {
        return {
            value: Serializable.toJSON(this._value),
            isInclusive: this._isInclusive,
        };
    }
}
//# sourceMappingURL=bound.js.map